export default __webpack_public_path__ + "static/media/directory.4bcb29de.svg";